var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h5',{staticClass:"stepTitle"},[_vm._v(_vm._s(_vm.$t('Languages')))]),_c('select-languages')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }